import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import ErrorTooltip from "../../../others/error-tooltip/index.js";
import * as S from "./styled.js";
const CustomFlatpickrCalendarInput = ({ value: _value , defaultValue , inputRef , onFocus , error , hasError =false , disabled =false , isFocused =false , ...rest })=>{
    const inputNode = useRef(null);
    const handleInputRef = useCallback((node)=>{
        inputNode.current = node;
        inputRef(node);
    }, [
        inputRef
    ]);
    useEffect(()=>{
        if (document.activeElement === inputNode.current && !isFocused) {
            inputNode.current?.blur();
        }
    }, [
        isFocused
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(S.CalendarInput, {
                className: "calendar-input",
                defaultValue: defaultValue,
                ref: handleInputRef,
                onFocus: onFocus,
                disabled: disabled,
                $hasError: hasError,
                $isFocused: isFocused,
                ...rest
            }),
            inputNode.current && /*#__PURE__*/ _jsx(ErrorTooltip, {
                referenceElement: inputNode.current,
                error: error,
                isVisible: !isFocused && !!hasError
            })
        ]
    });
};
export default CustomFlatpickrCalendarInput;

//# sourceMappingURL=index.js.map